import { render, staticRenderFns } from "./FormReward.vue?vue&type=template&id=40e9d35a&scoped=true"
import script from "./FormReward.vue?vue&type=script&lang=js"
export * from "./FormReward.vue?vue&type=script&lang=js"
import style0 from "./FormReward.vue?vue&type=style&index=0&id=40e9d35a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e9d35a",
  null
  
)

export default component.exports